module.exports = __webpack_public_path__ + "media/images/icons/link-intact-2b4a8df762dc9dee5ee831f6ee7223db.svg";